module.exports = __webpack_public_path__ + "img/15.64ff7ed1.gif";